__turbopack_export_value__({
  "body-logo-18": "OpeningContainer-module-scss-module__ashsDq__body-logo-18",
  "body-text-12": "OpeningContainer-module-scss-module__ashsDq__body-text-12",
  "body-text-14": "OpeningContainer-module-scss-module__ashsDq__body-text-14",
  "body-text-16": "OpeningContainer-module-scss-module__ashsDq__body-text-16",
  "body-text-18": "OpeningContainer-module-scss-module__ashsDq__body-text-18",
  "body-text-20": "OpeningContainer-module-scss-module__ashsDq__body-text-20",
  "body-text-24": "OpeningContainer-module-scss-module__ashsDq__body-text-24",
  "body-text-24-2": "OpeningContainer-module-scss-module__ashsDq__body-text-24-2",
  "body-text-heading-2": "OpeningContainer-module-scss-module__ashsDq__body-text-heading-2",
  "body-text-heading-3": "OpeningContainer-module-scss-module__ashsDq__body-text-heading-3",
  "body-text-medium-14": "OpeningContainer-module-scss-module__ashsDq__body-text-medium-14",
  "body-text-medium-16": "OpeningContainer-module-scss-module__ashsDq__body-text-medium-16",
  "body-text-medium-18": "OpeningContainer-module-scss-module__ashsDq__body-text-medium-18",
  "body-text-medium2-18": "OpeningContainer-module-scss-module__ashsDq__body-text-medium2-18",
  "body-text2-14": "OpeningContainer-module-scss-module__ashsDq__body-text2-14",
  "body-text2-16": "OpeningContainer-module-scss-module__ashsDq__body-text2-16",
  "button-primary-text": "OpeningContainer-module-scss-module__ashsDq__button-primary-text",
  "button-text": "OpeningContainer-module-scss-module__ashsDq__button-text",
  "button2-text": "OpeningContainer-module-scss-module__ashsDq__button2-text",
  "card-shadow": "OpeningContainer-module-scss-module__ashsDq__card-shadow",
  "container__button": "OpeningContainer-module-scss-module__ashsDq__container__button",
  "container__inner": "OpeningContainer-module-scss-module__ashsDq__container__inner",
  "effect-menu": "OpeningContainer-module-scss-module__ashsDq__effect-menu",
  "header-1": "OpeningContainer-module-scss-module__ashsDq__header-1",
  "main-container": "OpeningContainer-module-scss-module__ashsDq__main-container",
  "main-footer-container": "OpeningContainer-module-scss-module__ashsDq__main-footer-container",
  "main-header-container": "OpeningContainer-module-scss-module__ashsDq__main-header-container",
  "txt-12-bold": "OpeningContainer-module-scss-module__ashsDq__txt-12-bold",
  "txt-14-bold": "OpeningContainer-module-scss-module__ashsDq__txt-14-bold",
  "txt-14-bold-caps": "OpeningContainer-module-scss-module__ashsDq__txt-14-bold-caps",
  "txt-14-med": "OpeningContainer-module-scss-module__ashsDq__txt-14-med",
  "txt-16-bold": "OpeningContainer-module-scss-module__ashsDq__txt-16-bold",
  "txt-16-med": "OpeningContainer-module-scss-module__ashsDq__txt-16-med",
  "txt-18-bold": "OpeningContainer-module-scss-module__ashsDq__txt-18-bold",
  "txt-18-medium": "OpeningContainer-module-scss-module__ashsDq__txt-18-medium",
  "txt-18-medium-24": "OpeningContainer-module-scss-module__ashsDq__txt-18-medium-24",
  "txt-24-semi": "OpeningContainer-module-scss-module__ashsDq__txt-24-semi",
});
